import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { MFS_LOGO } from './logoData';

export function FinalCTA() {
  return (
    <section className="py-20 bg-[#F8F6F1]">
      <div className="container mx-auto px-8 text-center">
        <h2 
          className="text-4xl md:text-5xl font-bold text-[#1a1a1a] mb-6"
          
        >
          Ready to Transform Your Workspace?
        </h2>
        <p className="text-gray-600 text-lg mb-10 max-w-2xl mx-auto">
          Whether you need one workstation or a complete floor plan, 
          we're here to help you create the perfect office environment.
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <Link to="/products">
            <Button className="bg-[#1a1a1a] hover:bg-[#2a2a2a] text-white rounded-none px-10 py-6 text-sm tracking-[0.15em] font-bold">
              BROWSE PRODUCTS
            </Button>
          </Link>
          <Link to="/contact">
            <Button variant="outline" className="border-2 border-[#1a1a1a] text-[#1a1a1a] hover:bg-[#1a1a1a] hover:text-white rounded-none px-10 py-6 text-sm tracking-[0.15em] font-bold">
              CONTACT US
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}

export function PremiumFooter({ onSwitchToClassic }) {
  return (
    <footer className="bg-[#1e2330] text-white py-16" data-testid="premium-footer">
      <div className="container mx-auto px-4 sm:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-8 mb-12">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-2">
            <img 
              src={MFS_LOGO}
              alt="Modular Furniture Store"
              className="h-16 w-auto mb-3"
            />
            <p className="text-gray-400 text-xs mb-2 font-medium">
              A brand of Ezeefit Modular Furniture Pvt. Ltd.
            </p>
            <p className="text-gray-400 text-sm mb-4 max-w-md leading-relaxed">
              Delivering scalable office furniture solutions for growing corporates since 2014. From concept to installation — complete workspace execution under one roof.
            </p>
            <div className="flex items-center gap-4">
              <span className="text-[#c5a059] text-sm">GST Registered</span>
              <span className="text-[#c5a059] text-sm">Made in India</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold mb-4 text-[#c5a059] tracking-wider text-sm">QUICK LINKS</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li><Link to="/products" className="hover:text-white transition-colors">All Products</Link></li>
              <li><Link to="/bulk-inquiry" className="hover:text-white transition-colors">Bulk Inquiry</Link></li>
              <li><Link to="/blog" className="hover:text-white transition-colors">Knowledge Hub</Link></li>
              <li><Link to="/pricing-guide" className="hover:text-white transition-colors">Pricing Guide</Link></li>
              <li><Link to="/comparison-guide" className="hover:text-white transition-colors">Comparison Guide</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact Us</Link></li>
              <li><Link to="/legacy" className="hover:text-white transition-colors">Our Legacy</Link></li>
              <li><Link to="/sitemap" className="hover:text-white transition-colors">Sitemap</Link></li>
            </ul>
          </div>

          {/* Cities We Serve */}
          <div data-testid="footer-cities-column">
            <h4 className="font-bold mb-4 text-[#c5a059] tracking-wider text-sm">CITIES WE SERVE</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li><Link to="/office-furniture-mumbai" className="hover:text-white transition-colors">Mumbai</Link></li>
              <li><Link to="/office-furniture-navi-mumbai" className="hover:text-white transition-colors">Navi Mumbai</Link></li>
              <li><Link to="/office-furniture-thane" className="hover:text-white transition-colors">Thane</Link></li>
              <li><Link to="/office-furniture-pune" className="hover:text-white transition-colors">Pune</Link></li>
              <li><Link to="/office-furniture-bengaluru" className="hover:text-white transition-colors">Bangalore</Link></li>
              <li><Link to="/office-furniture-gurugram" className="hover:text-white transition-colors">Delhi NCR</Link></li>
              <li><Link to="/office-furniture-hyderabad" className="hover:text-white transition-colors">Hyderabad</Link></li>
              <li><Link to="/office-furniture-chennai" className="hover:text-white transition-colors">Chennai</Link></li>
              <li><Link to="/office-furniture-ahmedabad" className="hover:text-white transition-colors">Ahmedabad</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold mb-4 text-[#c5a059] tracking-wider text-sm">CONTACT</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li>hello@modularfurniturestore.com</li>
              <li>+91 9594685818</li>
              <li>+91 9820042100</li>
              <li className="pt-2">Mumbai, Maharashtra</li>
            </ul>
            {/* Social */}
            <div className="mt-5">
              <a
                href="https://www.instagram.com/modularfurniturestore/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-gray-400 hover:text-white transition-colors text-sm"
                data-testid="footer-instagram-link"
              >
                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
                @modularfurniturestore
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-sm">
            © 2024 Modular Furniture Store by Ezeefit. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-gray-500 text-sm">
            <Link to="/policies" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/policies" className="hover:text-white transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
